<div class="image-container">
  @if (!imageLoaded() && !imageNotFound()) {
    <app-pan-spinner></app-pan-spinner>
  }

  @if (!imageNotFound()) {
    <img
      (error)="updateUrl()"
      (load)="imageFinishedLoading()"
      [src]="url()"
      [style.display]="getImageDisplayState()"
      class="suspect-image"
      data-testid="suspectImage"
    />
  } @else {
    Image not available.
  }
</div>
